import { capitalize } from 'lodash';

export const SUMMARY = 'summary';
export const COMPARISON = 'comparison';
export const INBOUND_REFERRAL_SUMMARY = 'summary/inbound_referral';

export const AI_PROMPT_TYPES = [
  { name: 'Summary', id: SUMMARY },
  { name: 'Comparison', id: COMPARISON },
];

const AI_PROMPT_TYPE_NAMES = [...AI_PROMPT_TYPES, { name: 'Inbound Referral Summary', id: INBOUND_REFERRAL_SUMMARY }];

export const aiPromptTypeName = (type: string | null | undefined): string =>
  AI_PROMPT_TYPE_NAMES.find((option) => option.id === type)?.name ?? capitalize(type || '—');

export const INBOUND_REFERRAL_OUTPUT_DEFINITION_HELP =
  "The summary's sections, in order. For each, name it and describe what belongs in it.";

export const AI_PROMPT_TYPE_FILTER_OPTIONS = AI_PROMPT_TYPES;

export const AI_PROMPT_PUBLISHED_FILTER_OPTIONS = [
  { name: 'Yes', id: 'true' },
  { name: 'No', id: 'false' },
];

export const INBOUND_REFERRAL_TARGET_OBJECT = { name: 'Inbound Referral', id: 'Workflow' };

export const ADMISSION_PROMPT_TARGET_OBJECTS = [
  { name: 'Admission', id: 'Review::Admission' },
  INBOUND_REFERRAL_TARGET_OBJECT,
];

export const AI_PROMPT_TARGET_OBJECTS = [
  { name: 'Concurrent Review', id: 'Review::Authorization' },
  { name: 'Referral', id: 'Review::Referral' },
  { name: 'Workspace', id: 'Summarization' },
];

export const AI_PROMPT_TARGET_OBJECT_FILTER_OPTIONS = AI_PROMPT_TARGET_OBJECTS;
